import { CMMILevel, CMMIRating, AgenticDimensionInfo } from "../types";

/**
 * CMMI Rating Levels (0-4)
 * Based on Network Overdrive's Profit Stacks methodology
 */
export const CMMI_LEVELS: Record<CMMIRating, CMMILevel> = {
  0: {
    value: 0,
    label: "Chaotic",
    color: "#f44336", // Red
    description: "Causes more problems than it fixes",
  },
  1: {
    value: 1,
    label: "Reactive",
    color: "#ff9800", // Orange
    description: "Lot of effort for insufficient return",
  },
  2: {
    value: 2,
    label: "Proactive",
    color: "#ffeb3b", // Yellow
    description: "Sufficient, maintaining status quo",
  },
  3: {
    value: 3,
    label: "Strategic",
    color: "#2196f3", // Blue
    description: "Adding value but leaving gaps",
  },
  4: {
    value: 4,
    label: "Profit",
    color: "#4caf50", // Green
    description: "Generating tangible measurable value",
  },
};

/**
 * Get CMMI level info by rating value
 */
export const getCMMILevel = (rating: CMMIRating): CMMILevel => {
  return CMMI_LEVELS[rating];
};

/**
 * Get color for a given CMMI rating
 */
export const getRatingColor = (rating: CMMIRating): string => {
  return CMMI_LEVELS[rating].color;
};

/**
 * Agentic Potential Score dimensions
 * Each dimension scored 0-4, total 0-20
 */
export const AGENTIC_DIMENSIONS: AgenticDimensionInfo[] = [
  {
    key: "automatability",
    label: "Automatability",
    description: "Can AI perform this task?",
  },
  {
    key: "impact",
    label: "Impact",
    description: "Business impact: revenue, cost, quality, risk",
  },
  {
    key: "frequency",
    label: "Frequency",
    description: "How frequently does this task occur?",
  },
  {
    key: "dataReadiness",
    label: "Data Readiness",
    description: "Is quality data accessible for AI?",
  },
  {
    key: "riskProfile",
    label: "Risk Profile",
    description: "Safety level for automation (inverted: higher = safer)",
  },
];

/**
 * Calculate total agentic score (0-20)
 */
export const calculateAgenticTotal = (
  score: Record<string, number>,
): number => {
  return AGENTIC_DIMENSIONS.reduce((total, dim) => {
    return total + (score[dim.key] || 0);
  }, 0);
};
